<template>
    <div>
        <slot
            name="default"
            :buildHiddenData="buildHiddenData"
            :dataElm="dataElm"
            :ignoredData="ignoredData"
        ></slot>

        <!--<template v-for="({name, value}) in dataElm">
            <template v-if="!ignoredData.includes(index)">
                {{name}} => {{value}} |
            </template>
            <input type="hidden" :name="name" :value="value" v-if="!ignoredData.includes(name)">
        </template>-->
    </div>
</template>

<script>
export default {
    props: {
        ignoredData: {
            type: Array,
            default: () => [],
        },
        targetSelector: {
            type: String,
            default: ".filter-search",
        },
    },
    data() {
        return {
            dataElm: {},
        };
    },
    mounted() {
        this.emitter.on("updateDataHidden", ({ key, data }) => {
            console.log(key, data);
            this.updateDataHidden(key, data);
        });
    },
    methods: {
        updateDataHidden(key, data) {
            this.dataElm[key] = data;
            this.$forceUpdate();
        },
        buildHiddenData(evt) {
            this.emitter.emit("pageLoading", {
                showLoading: true,
                message: "",
            });

            let containers = document.querySelectorAll(this.targetSelector);
            let formVisible = null;

            if (containers.length === 0) return true;

            for (let container of containers) {
                if (
                    container.offsetWidth > 0 ||
                    container.offsetHeight > 0 ||
                    container.getClientRects().length > 0
                ) {
                    formVisible = container;
                    break;
                }
            }

            if (!formVisible) return true;

            const inputs = formVisible.querySelectorAll("input");
            if (inputs.length === 0) return true;

            this.dataElm = Array.from(inputs)
                .filter((input) => {
                    if (input.type === "checkbox" || input.type === "radio") {
                        return input.checked;
                    }
                    return true;
                })
                .map((input) => ({
                    name: input.name,
                    value: input.value,
                }))
                .filter((item) => item.name);

            // Fix: Wait for DOM to update with new hidden inputs before submitting
            if (this.dataElm.length > 0) {
                evt.preventDefault();
                this.$nextTick(() => {
                    evt.target.submit();
                });
            }

            return true;
        },
    },
};
</script>
